import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import PrivateRoute from "./routes/privateRoutes";
import { CircularProgress } from "@mui/material";


/* =======================
   Lazy Loaded Pages
======================= */

// Public pages
import HomePage from "./pages/homePage";
const SearchProperty = lazy(() => import("./pages/searchPropertry"));
const ViewDetails = lazy(() => import("./components/viewDetails"));
const AboutUs = lazy(() => import("./pages/aboutUs"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const BlogListPage = lazy(() => import("./pages/blogs"));
const BlogDetailsPage = lazy(() => import("./pages/blogDetailPage"));
const AllProjectsPage = lazy(() => import("./pages/allProjects"));
const ProjectDetailPages = lazy(() => import("./pages/projectDetails"));
const InvestorPage = lazy(() => import("./pages/Investors"));
const Careers = lazy(() => import("./pages/Careers"));
const Page = lazy(() => import("./pages/Page"));
const NotFound = lazy(() => import("./pages/PageNotFound"));

// Auth
const ForgetPassword = lazy(() => import("./pages/forgetPassword"));
const ResetPassword = lazy(() => import("./pages/resetPassword"));

// Policies
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));

// Verification
const StartVerification = lazy(() => import("./pages/PropertyVerification/startVerification"));
const LocationVerification = lazy(() => import("./pages/PropertyVerification/locationVerification"));
const PropertyVerification = lazy(() => import("./pages/PropertyVerification/propertyVerification"));

// Payment
const Packages = lazy(() => import("./payment_module/Packages"));

// Post property
const PostProperty = lazy(() => import("./pages/postProperty"));
const PostPropertyFree = lazy(() => import("./pages/AboutPostProperty"));

// Dashboard
const Profile = lazy(() => import("./components/userDashboard/profile"));

const DashboardLayout = lazy(() => import("./components/userDashboard/adminSidebar"));

const UserListings = lazy(() => import("./components/userDashboard/userListing"));
const Responses = lazy(() => import("./components/userDashboard/responses"));
const Wishlist = lazy(() => import("./components/userDashboard/wishlist"));
const ChangePassword = lazy(() => import("./components/userDashboard/changePassword"));
const UserProfile = lazy(() => import("./components/userDashboard/userProfile"));

function App() {
  return (
<div className="App" style={{ display: "flex",
   flexDirection: "column",
    minHeight: "100vh", minWidth: "100vw",justifyContent:"center" ,alignItems:"center"}} > 
        <Suspense fallback={<CircularProgress />}>
        <Routes>

          {/* ================= PUBLIC ROUTES ================= */}
          <Route path="/" element={<HomePage />} />
          <Route path="/search-results" element={<SearchProperty />} />
          <Route path="/search-results/:slug" element={<SearchProperty />} />
          <Route path="/viewDetails/:slug/:id" element={<ViewDetails />} />

          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/contactUs" element={<ContactUs />} />

          <Route path="/blogs" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogDetailsPage />} />

          <Route path="/projects/explore" element={<AllProjectsPage />} />
          <Route path="/project/:slug" element={<ProjectDetailPages />} />

          <Route path="/investor" element={<InvestorPage />} />
          <Route path="/careers" element={<Careers />} />

          <Route path="/plans" element={<Packages />} />

          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route path="/start-verification/:lat/:lng/:id" element={<StartVerification />} />
          <Route path="/location-verification/:lat/:lng/:id" element={<LocationVerification />} />
          <Route path="/property-verification/:id" element={<PropertyVerification />} />

          <Route
            path="/post-your-property-free"
            element={<Navigate to="/post-properties/basic-info" replace />}
          />

          <Route path="/post-property-ads-free" element={<PostPropertyFree />} />

          {/* CMS Dynamic Page */}
          <Route path="/:slug" element={<Page />} />

          {/* ================= PROTECTED ROUTES ================= */}
          <Route element={<PrivateRoute />}>
            <Route path="/post-properties/*" element={<PostProperty />} />

            <Route
              path="/create-listing-2"
              element={<Navigate to="/post-properties/basic-info" replace />}
            />
             <Route path="/profile" element={<Profile />} />
            <Route path="/user-profile" element={<DashboardLayout />}>
              <Route index element={<UserListings />} />
              <Route path="responses" element={<Responses />} />
              <Route path="wishlist" element={<Wishlist />} />
              <Route path="change-password" element={<ChangePassword />} />
              <Route path="manage-profile" element={<UserProfile />} />
            </Route>
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />

        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
